import { BaseContainerModel } from '../../base-container.model';
import * as fromDatatype from "../../../datatype-library/index";

export class BankReconCashbookBalanceOutputDtoModel extends BaseContainerModel {
    last_cashbook_closing_balance: fromDatatype.NumericDatatypeInterface;
    total_closing_balance_calculated:fromDatatype.NumericDatatypeInterface;
    last_cashbook_bank_stmt_closing_balance: fromDatatype.NumericDatatypeInterface;
}
